/* Collection page: Impulse filter/sort behaviour (theme.Collection + PriceRange) rebuilt on the
   Section Rendering API, without Impulse's theme.js / noUiSlider. */
(() => {
  const E = window.tcImpulse;
  const money = (v) => {
    const fmt = window.tcMoneyFormat || '${{amount}}';
    const n = Number(v).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, n.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(v)).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace('.', ','));
  };
  let container, sectionId, filterDrawer, busy = false;
  const cache = {};

  /* ---- noUiSlider look-alike on Impulse's .price-range markup (step 10, connect) ---- */
  function priceRange(el) {
    const slider = el.querySelector('.price-range__slider');
    if (!slider || slider.dataset.tcInit) return;
    slider.dataset.tcInit = '1';
    const min = parseFloat(el.dataset.min) || 0, max = parseFloat(el.dataset.max) || 100, step = 10;
    let vals = [parseFloat(el.dataset.minValue) || 0, parseFloat(el.dataset.maxValue) || max];
    slider.className += ' noUi-target noUi-ltr noUi-horizontal noUi-txt-dir-ltr';
    slider.innerHTML = '<div class="noUi-base"><div class="noUi-connects"><div class="noUi-connect"></div></div>' +
      [0, 1].map((i) => `<div class="noUi-origin"><div class="noUi-handle noUi-handle-${i ? 'upper' : 'lower'}" data-handle="${i}" tabindex="0" role="slider" aria-orientation="horizontal"><div class="noUi-touch-area"></div></div></div>`).join('') + '</div>';
    const origins = slider.querySelectorAll('.noUi-origin'), connect = slider.querySelector('.noUi-connect');
    const pct = (v) => ((v - min) / (max - min)) * 100;
    const snap = (v) => {
      if (v >= max) return max;
      if (v <= min) return min;
      return Math.min(max, Math.max(min, Math.round((v - min) / step) * step + min));
    };
    const draw = () => {
      const a = pct(vals[0]), b = pct(vals[1]);
      origins[0].style.transform = `translate(${(a - 100) * 10}%, 0px)`;
      origins[1].style.transform = `translate(${(b - 100) * 10}%, 0px)`;
      origins[0].style.zIndex = 5; origins[1].style.zIndex = 4;
      connect.style.transform = `translate(${a}%, 0px) scale(${(b - a) / 100}, 1)`;
      origins.forEach((o, i) => {
        const h = o.firstChild;
        h.setAttribute('aria-valuemin', i ? vals[0].toFixed(1) : min.toFixed(1));
        h.setAttribute('aria-valuemax', i ? Math.ceil(max).toFixed(1) : vals[1].toFixed(1));
        h.setAttribute('aria-valuenow', vals[i].toFixed(1));
        h.setAttribute('aria-valuetext', vals[i].toFixed(2));
      });
      el.querySelector('.price-range__display-min').innerHTML = money(vals[0]);
      el.querySelector('.price-range__display-max').innerHTML = money(vals[1]);
    };
    const change = () => {
      el.querySelector('.price-range__input-min').value = vals[0].toFixed(2);
      el.querySelector('.price-range__input-max').value = vals[1].toFixed(2);
      render(new URLSearchParams(new FormData(el.closest('form'))));
    };
    origins.forEach((o, i) => {
      const h = o.firstChild;
      h.addEventListener('pointerdown', (e) => {
        e.preventDefault();
        h.setPointerCapture(e.pointerId);
        h.classList.add('noUi-active');
        slider.classList.add('noUi-state-drag');
        const base = slider.querySelector('.noUi-base').getBoundingClientRect();
        const move = (ev) => {
          let v = snap(min + ((ev.clientX - base.left) / base.width) * (max - min));
          vals[i] = i ? Math.max(v, vals[0]) : Math.min(v, vals[1]);
          draw();
        };
        const up = () => {
          h.removeEventListener('pointermove', move);
          h.removeEventListener('pointerup', up);
          h.classList.remove('noUi-active');
          slider.classList.remove('noUi-state-drag');
          change();
        };
        h.addEventListener('pointermove', move);
        h.addEventListener('pointerup', up);
      });
      h.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        const v = snap(vals[i] + (e.key === 'ArrowRight' ? step : -step));
        vals[i] = i ? Math.max(v, vals[0]) : Math.min(v, vals[1]);
        draw();
        change();
      });
    });
    draw();
  }

  /* ---- filters ---- */
  function renderActiveTag(parent, el) {
    const text = parent.querySelector('.tag__text');
    if (parent.classList.contains('tag--active')) { parent.classList.remove('tag--active'); return; }
    parent.classList.add('tag--active');
    if (el.closest('li').classList.contains('tag--remove')) { parent.remove(); return; }
    document.querySelectorAll('.tag-list--active-tags').forEach((list) => {
      const li = document.createElement('li'), a = document.createElement('a');
      li.classList.add('tag', 'tag--remove');
      a.classList.add('btn', 'btn--small');
      a.innerText = text ? text.innerText : '';
      li.appendChild(a);
      list.appendChild(li);
    });
  }
  function headerH() { const h = document.querySelector('.site-header'); return h ? h.offsetHeight : 0; }
  function updateScroll(animate) {
    let top = matchMedia('(max-width: 768px)').matches
      ? document.querySelector('[data-scroll-to]').offsetTop - 60
      : document.getElementById('CollectionAjaxResult').offsetTop + 1;
    const sh = document.getElementById('SiteHeader');
    if (sh && sh.dataset.sticky === 'true') top -= headerH();
    window.scrollTo(animate ? { top, behavior: 'smooth' } : { top });
  }
  function stickyTops() {
    const t = headerH() + 10 + 'px';
    const f = document.querySelector('.collection-filter');
    if (f) f.style.top = t;
    const s = document.querySelector('.grid__item--sidebar');
    if (s) s.style.top = t;
  }
  function render(params, push = true) {
    const cur = new URLSearchParams(location.search);
    if (cur.get('sort_by') && !params.get('sort_by')) params.set('sort_by', cur.get('sort_by'));
    if (location.href.indexOf('collections/vendors') > -1 && cur.get('q')) params.append('q', cur.get('q'));
    const url = `${location.pathname}?section_id=${sectionId}&${params}`;
    const p = cache[url] ? Promise.resolve(cache[url]) : fetch(url).then((r) => r.text()).then((h) => (cache[url] = h));
    if (push) history.pushState({ searchParams: params.toString() }, '', `${location.pathname}${params.toString() ? '?' + params : ''}`);
    return p.then((html) => {
      const dom = new DOMParser().parseFromString(html, 'text/html');
      const open = [...document.querySelectorAll('#CollectionSidebar .collapsible-trigger.is-open')].map((t) => t.dataset.collapsibleId);
      open.forEach((id) => dom.querySelectorAll(`[data-collapsible-id="${id}"]`).forEach((el) => {
        if (el.classList.contains('collapsible-content--sidebar')) el.style.height = 'auto';
        el.classList.add('is-open');
      }));
      document.getElementById('CollectionAjaxContent').innerHTML = dom.getElementById('CollectionAjaxContent').innerHTML;
      bind();
      updateScroll(false);
      busy = false;
    });
  }
  function bind() {
    E.collapsibles(container);
    E.aos(container);
    filterDrawer = E.Drawer('FilterDrawer', 'collection-filters');
    stickyTops();
    container.querySelectorAll('.price-range').forEach(priceRange);
    container.querySelectorAll('.tag-list a').forEach((a) => a.addEventListener('click', (e) => {
      filterDrawer && filterDrawer.close();
      if (a.classList.contains('no-ajax')) return;
      e.preventDefault();
      if (busy) return;
      busy = true;
      renderActiveTag(a.parentNode, a);
      updateScroll(true);
      document.querySelector('.collection-grid__wrapper').classList.add('unload');
      render(new URL(a.href).searchParams);
    }));
    container.querySelectorAll('.filter-form').forEach((form) => form.addEventListener('input', (e) => {
      const el = e.target;
      if (el.classList.contains('price-range__input')) return;
      filterDrawer && filterDrawer.close();
      if (el.classList.contains('no-ajax')) return;
      e.preventDefault();
      if (busy) return;
      busy = true;
      renderActiveTag(el.closest('li'), el);
      updateScroll(true);
      document.querySelector('.collection-grid__wrapper').classList.add('unload');
      render(new URLSearchParams(new FormData(form)));
    }));
    const sort = document.getElementById('SortBy');
    if (sort) sort.addEventListener('change', () => {
      const q = new URLSearchParams(location.search);
      q.set('sort_by', sort.value || sort.dataset.defaultSortby);
      q.delete('page');
      window.location.search = decodeURIComponent(q.toString());
    });
  }
  function init() {
    container = document.querySelector('[data-section-type="collection-template"]');
    if (!container || !E) return;
    sectionId = container.dataset.sectionId;
    bind();
    let t;
    window.addEventListener('resize', () => { clearTimeout(t); t = setTimeout(stickyTops, 500); });
    window.addEventListener('popstate', () => render(new URL(location.href).searchParams, false));
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
